// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"662":"9956d64f","702":"fdc77c7e"}[chunkId] + ".chunk.css";
};